import { CategoryPathModel, CategoryType, NodeData, LocalizedName } from '@crema/models/Category';
import { NodeModel } from '@minoru/react-dnd-treeview';
import find from 'lodash/find';
import compact from 'lodash/compact';
import isEmpty from 'lodash/isEmpty';

const LOCALIZES = ['KO', 'EN', 'JA'];

export function convertPathModelToNodeModel2(pathModel: CategoryPathModel): NodeModel {
  const { id, path, position, localizedNames, display } = pathModel;

  let defaultLocalizedName = '';

  for (const LOCALIZE of LOCALIZES) {
    const localized = find(localizedNames, (name) => name.langCode === LOCALIZE);
    if (localized) {
      defaultLocalizedName = localized.name;
      break;
    }
  }

  let parentId = 0;

  const ids = path.split('.');

  if (ids.length > 1) {
    parentId = Number(ids[ids.length - 2]);
  }

  return {
    id,
    parent: parentId,
    text: defaultLocalizedName || '',
    droppable: !parentId,
    data: {
      position,
      localizedNames,
      display,
    },
  };
}

export function convertPathModelToNodeModel(pathModel: CategoryPathModel): NodeModel {
  const { id, path, position, localizedNames, display } = pathModel;

  let defaultLocalizedName = '';

  for (const LOCALIZE of LOCALIZES) {
    const localized = find(localizedNames, (name) => name.langCode === LOCALIZE);
    if (localized) {
      defaultLocalizedName = localized.name;
      break;
    }
  }

  let parentId = 0;

  const ids = path.split('.');

  if (ids.length > 1) {
    parentId = Number(ids[ids.length - 2]);
  }

  return {
    id,
    parent: parentId,
    text: defaultLocalizedName || '',
    droppable: !parentId,
    data: {
      position,
      localizedNames,
      display,
    },
  };
}

export function convertNodeModelToPathModel(nodeModel: NodeModel): CategoryPathModel {
  const { id, parent, text, data } = nodeModel;

  const { position, localizedNames } = data as NodeData;

  return {
    id: id as number,
    name: text,
    position,
    localizedNames,
    path: parent ? `${parent}.${id}` : `${id}`,
    display: !!(data as any)?.display,
  };
}

export function convertNodeModelToCategoryType(nodeModel: any): CategoryType {
  const { id, parent, data } = nodeModel;

  const { localizedNames } = data as NodeData;

  const nameInKo = find(localizedNames, (name) => name.langCode === 'KO');
  const nameInEn = find(localizedNames, (name) => name.langCode === 'EN');
  const nameInJa = find(localizedNames, (name) => name.langCode === 'JA');

  let display = '';

  if ((data as any)?.display === false) {
    display = 'N';
  }
  if ((data as any)?.display === true) {
    display = 'Y';
  }

  return {
    id,
    name: nameInKo?.name || '',
    nameInEn: nameInEn?.name || '',
    nameInJa: nameInJa?.name || '',
    parent,
    display,
  };
}

export function convertCategoryTypeToPathModel(category: CategoryType, localizedNames: Array<LocalizedName> = []) {
  const { id, name, nameInEn, nameInJa, parent, display } = category;
  const newLocalizedNames = [];

  if (!isEmpty(name)) {
    const localizedName = find(localizedNames, (name) => name.langCode === 'KO');
    if (!localizedName) {
      newLocalizedNames.push({ langCode: 'KO', name });
    }
  }

  if (!isEmpty(nameInEn)) {
    const localizedName = find(localizedNames, (name) => name.langCode === 'EN');
    if (!localizedName) {
      newLocalizedNames.push({ langCode: 'EN', name: nameInEn });
    }
  }

  if (!isEmpty(nameInJa)) {
    const localizedName = find(localizedNames, (name) => name.langCode === 'JA');
    if (!localizedName) {
      newLocalizedNames.push({ langCode: 'JA', name: nameInJa });
    }
  }

  newLocalizedNames.push(
    ...localizedNames.map((localizedName: LocalizedName) => {
      switch (localizedName.langCode) {
        case 'KO':
          return !isEmpty(name) && { ...localizedName, name };
        case 'JA':
          return !isEmpty(nameInJa) && { ...localizedName, name: nameInJa };
        case 'EN':
          return !isEmpty(nameInEn) && { ...localizedName, name: nameInEn };
      }
    }),
  );

  return {
    id,
    parentId: parent,
    display: display === 'Y',
    localizedNames: compact(newLocalizedNames),
  };
}

export const getSubCategoryByParentId = (parent: number, categories: CategoryType) => {
  return;
};
